export const SUBSCRIPTION_PLAN = {
  PERSONAL_MONTHLY: 'prod_MMKwNLdDS8sQzQ',
  TEAM: 'prod_MML2RSdXeHcZWh',
  ORGANIZATION_LICENSES: 'prod_PoVHmwhBleUISJ',
  PERSONAL_ANNUAL: 'prod_Q4CMIjrpNLnP2c',
  TRAIL: 'trial',
  RC_PROMO_TEAM_ADMIN_LIFE_TIME: 'rc_promo_team_admin_lifetime',
  RC_PROMO_TEAM_OWNER_LIFE_TIME: 'rc_promo_team_owner_lifetime',
  RC_PROMO_TEAM_MEMBER_MONTHLY: 'rc_promo_team_member_monthly',
  RC_PROMO_TEAM_MEMBER_LIFE_TIME: 'rc_promo_team_member_lifetime',
  RC_PROMO_TEAM_MEMBER_CUSTOM: 'rc_promo_team_member_custom',
  TEAM_SIZE_5: 'prod_MML2RSdXeHcZWh',
  LIFE_TIME: 'prod_UC9N7yiJqb26xr'
};

export const ACTIVE_SUBSCRIPTION_PRODUCT_IDENTIFIERS = [
  SUBSCRIPTION_PLAN.PERSONAL_MONTHLY,
  SUBSCRIPTION_PLAN.TEAM,
  SUBSCRIPTION_PLAN.LIFE_TIME
];

export const SUBSCRIPTION_INFO_STORE = {
  APP_STORE: 'app_store',
  PLAY_STORE: 'play_store',
  NO_PLAN: 'no_plan'
};

export const SUBSCRIPTION_PRICE = {
  TEAM: 4.99,
  PERSONAL_MONTHLY: 9.99,
  PERSONAL_ANNUAL: 75,
  ORGANIZATION: 19.99,
  PERSONAL_QUARTERLY: 25,
  LIFE_TIME: 150
};

export const SUBSCRIPTION_PRICE_ID = {
  TEAM: 'price_1NvYTNAbucJVfCqsAJMDsrlF',
  PERSONAL_MONTHLY: 'price_1LdcGhAbucJVfCqsbZ86R8v2',
  ORGANIZATION: 'price_1OysHCAbucJVfCqsxSDxQ9hy',
  PERSONAL_ANNUAL: 'price_1TDlQLAbucJVfCqsAh5ERpgr',
  PERSONAL_QUARTERLY: 'price_1TDllFAbucJVfCqsA5oVmcDt',
  LIFE_TIME: 'price_1TDl52AbucJVfCqsfukZxEXX'
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
};

export const NO_SUBSCRIPTION_PLAN = 'no_plan';
